import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/auth'
import axios from 'axios'

// const config = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASE_URL,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//   functionsUrl: process.env.REACT_APP_FUNCTIONS_URL
// }


// PROD
const config = {
  apiKey: "AIzaSyAn_W7DuQRP2Y8uzn3BrHzYnzcJGGO5c5w",
  authDomain: "implant-compare.firebaseapp.com",
  databaseURL: "https://implant-compare.firebaseio.com",
  projectId: "implant-compare",
  storageBucket: "implant-compare.appspot.com",
  messagingSenderId: "807764475515",
  functionsUrl: "us-central1-implant-compare.cloudfunctions.net"
};

// DEV
// const config = {
//   apiKey: "AIzaSyBhjFM0fMB501oOvOu4gWR_tG_lbd4pSTk",
//   authDomain: "dev-implant-compare.firebaseapp.com",
//   databaseURL: "https://dev-implant-compare.firebaseio.com",
//   projectId: "dev-implant-compare",
//   storageBucket: "dev-implant-compare.appspot.com",
//   messagingSenderId: "807764475515",
//   functionsUrl: "us-central1-dev-implant-compare.cloudfunctions.net"
// };

// STAGING
// const config = {
//   apiKey: "AIzaSyBRgyYJxnJqTZxfqtuW9R_ud6ZWCixxrUw",
//   authDomain: "stag-implant-compare.firebaseapp.com",
//   databaseURL: "https://stag-implant-compare.firebaseio.com",
//   projectId: "stag-implant-compare",
//   storageBucket: "stag-implant-compare.appspot.com",
//   messagingSenderId: "807764475515",
//   functionsUrl: "us-central1-stag-implant-compare.cloudfunctions.net"
// };

firebase.initializeApp(config);

const firebaseServerUrl = url => 'https://' + config.functionsUrl + '/' + url; // SERVER
// const firebaseServerUrl = url => 'http://localhost:8005/stag-implant-compare/us-central1/' + url; // LOCAL

async function fbRequest(endpoint, data) {
  let token = await getToken();

  return axios({
    method: 'POST',
    url: firebaseServerUrl(endpoint),
    crossDomain : true,
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      "Authorization": `Bearer ${token}`
    }
  })
}

export let auth = firebase.auth;
export let database = firebase.database();

// // STAGING
// const configSecond = {
//   apiKey: "AIzaSyBRgyYJxnJqTZxfqtuW9R_ud6ZWCixxrUw",
//   authDomain: "stag-implant-compare.firebaseapp.com",
//   databaseURL: "https://stag-implant-compare.firebaseio.com"
// };

// PROD
const configSecond = {
  apiKey: "AIzaSyAn_W7DuQRP2Y8uzn3BrHzYnzcJGGO5c5w",
  authDomain: "implant-compare.firebaseapp.com",
  databaseURL: "https://implant-compare.firebaseio.com"
};

export const secondaryApp = firebase.initializeApp(configSecond, "Secondary");

export function checkConnection() {
  let result = false;
  let connectedRef = firebase.database().ref(".info/connected");
  connectedRef.on("value", snap => {
    if (snap.val() && window.navigator.onLine) {
      result = true
    }
  });

  return result
}

async function getToken() {
  let user = auth().currentUser;
  return await user.getIdToken()
}

export function like(entryId) {
  return fbRequest('like', { entryId: entryId })
}

export function addView(entryId) {
  return fbRequest('addView', { entryId: entryId })
}

export async function handleNotification(subject, text) {
  let res = await fbRequest('handleNotification', { subject: subject, text: text });
  res = res.data;

  return res === 'success' ? res : 'reject'
}

export async function initUser(entryId, email, displayName) {
  await getToken();
  let res = await fbRequest('initUser', { entryId, email, displayName });
  res = res.data;

  if (res && res.token) {
    return firebase.auth().signInWithCustomToken(res.token).then(() => {
      return res.userType
    })
  } else {
    return res.userType
  }
}

export async function excludeContributorFromChannel(contributorId, id, updatedOwnerList) {
  return fbRequest('excludeContributorFromChannel', {contributorId, id, updatedOwnerList})
}

export async function createContributor(userData, channelSelect, user, password) {
  return fbRequest('createContributor', { userData, channelSelect, user, password })
}

// CHANNELS Requests
function sendRequestChannel(endpoint, channel) {
  return fbRequest(endpoint, { channel: channel })
  .then(res => res.data)
  .catch(error => console.error('Error:', error))
}

export async function putChannelUstream(channel) {
  return sendRequestChannel('putChannelUstream', channel)
}

export async function postChannelUstream(channel) {
  return sendRequestChannel('postChannelUstream', channel)
}

export async function deleteChannelUstream(channel) {
  return sendRequestChannel('deleteChannelUstream', channel)
}

// Requests
export function sendRequest(endpoint, requestObj) {
  return fbRequest(endpoint, requestObj)
    .then(res => res.data)
    .catch(error => console.error('Error:', error))
}

export function getAllVideosChannel(channel) {
  return sendRequest('getAllVideosChannel', { data: channel })
}

export function getAllPlaylistsChannel(channel) {
  return sendRequest('getAllPlaylistsChannel', { data: channel })
}

export function getAllVideosOfPlaylist(playlistId) {
  return sendRequest('getAllVideosOfPlaylist', { playlistId: playlistId })
}

export function deletePlaylistChannel(playlistId) {
  return sendRequest('deletePlaylistChannel', { playlistId: playlistId })
}

export function putAddVideoToPlaylist(playlistId, videoId) {
  return sendRequest('putAddVideoToPlaylist', { playlistId: playlistId, videoId: videoId})
}

export function deleteVideoFromPlaylist(playlistId, videoId) {
  return sendRequest('deleteVideoFromPlaylist', { playlistId: playlistId, videoId: videoId})
}

export function postCreatePlaylistChannel(channel, playlistTitle) {
  return sendRequest('postCreatePlaylistChannel', { data: channel, playlistTitle: playlistTitle })
}

export function postEditTitlePlaylist(playlistId, playlistTitle) {
  return sendRequest('postEditTitlePlaylist', { playlistId: playlistId, playlistTitle: playlistTitle })
}

export function sendRequestVideos(endpoint, data) {
  return fbRequest(endpoint, { data: data })
    .then(res => res.data)
    .catch(error => console.error('Error:', error))
}

export function getVideosEmbed(data) {
  return sendRequestVideos('getVideosEmbed', data)
}

function sendRequestPayment(endpoint, tokenObject, userId, itemId, eventCost, type) {
  return fbRequest(endpoint, { tokenObject, userId, itemId, eventCost, type })
    .then(res => res.data)
    .catch(error => {
      console.error('Error Payment:', error);
      return error
    })
}

export function postPayment(tokenObject, userId, itemId, eventCost, type) {
  return sendRequestPayment('createPaymentStripe', tokenObject, userId, itemId, eventCost, type)
}

export function postCreateStripeConnectAccount(email, userId) {
  return sendRequest('createStripeConnectAccount', { email: email, userId: userId })
}

export function postCreateStripeLink(stripeAccountId) {
  return sendRequest('createStripeLink', { accountId: stripeAccountId })
}

function sendRequestCustomerCardStripe(endpoint, tokenObject, userId, stripeAccountId) {
  return fbRequest(endpoint, { tokenObject, userId, stripeAccountId })
    .then(res => res.data)
    .catch(error => {
      console.error('Error Creating Card:', error);
      return error
    })
}

export function postCardToConnectedAccountStripe(tokenObject, userId, stripeAccountId) {
  return sendRequestCustomerCardStripe('addCardToConnectedAccountStripe', tokenObject, userId, stripeAccountId)
}

export function getConnectedAccountInfo(stripeAccountId) {
  return sendRequest('getConnectedAccountInfo', { stripeAccountId: stripeAccountId })
}



// WEBPACK FOOTER //
// ./src/services/firebase/firebase.js